var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "container mx-auto" };
const _hoisted_2 = { class: "p-20 mt-12 h-754px mx-auto border-2 border-orange border-solid bg-archiv bg-no-repeat bg-right-top" };
const _hoisted_3 = { class: "text-lg mb-2 font-weight-bold" };
const _hoisted_4 = { class: "border-2 border-orange border-solid h-570px overflow-scroll" };
const _hoisted_5 = ["data-id"];
const _hoisted_6 = { class: "flex justify-between mt-2" };
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/ _createStaticVNode("<footer class=\"container mx-auto mt-1\"><div class=\"p-0 w-11/12 mx-auto text-white text-center\"><a href=\"https://www.ufs-tools.com/datenschutzerklaerung.html\" class=\"text-white\" target=\"_blank\">Datenschutzerklärung</a>    |   <a href=\"https://www.ufs-tools.com/impressum.html\" class=\"text-white\" target=\"_blank\">Impressum</a>    |   <a href=\"https://www.ufs-tools.com/downloads/Handbuch.pdf\" class=\"text-white\" target=\"_blank\" title=\"Handbuch als PDF laden\">Handbuch</a></div></footer>", 1);
import { LaravelService } from "./LaravelService";
import { Sortable } from "sortablejs-vue3";
import { ref, computed, onMounted } from 'vue';
import axios from "axios";
import VueSimpleAlert from "vue3-simple-alert";
export const componentName = 'BookletBuilder';
const __default__ = {
    name: componentName,
    inheritAttrs: false,
};
export default /*#__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { setup(__props) {
        const laravel = new LaravelService();
        const project = ref(laravel.projectName());
        const csrf_token = ref(laravel.csrfToken());
        const baseUrl = '/api/project/';
        const path_to_pdfs = computed(() => baseUrl + project.value + '/pdf');
        const path_to_csv = computed(() => baseUrl + project.value + '/csv');
        const elements = ref([]);
        const sorted = ref([]);
        const sortable = ref(null);
        const setDisabled = ref(true);
        const index = ref(0);
        const alertOptions = {
            confirmButtonColor: '#b3b3b3'
        };
        const successOptions = {
            confirmButtonColor: '#b3b3b3',
            cancelButtonColor: '#ff7849',
        };
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield fetch(path_to_pdfs.value);
            const csv = yield fetch(path_to_csv.value);
            const resdatas = yield res.json();
            const csvdatas = yield csv.json();
            let ordered = [];
            csvdatas.forEach(function (csvdata) {
                let idx = 0;
                resdatas.forEach(function (resdata) {
                    if (resdata.filename === csvdata[2]) {
                        resdata.basename = csvdata[3];
                        ordered.push(resdata);
                        resdatas.splice(idx, 1);
                    }
                    idx++;
                });
            });
            elements.value = ordered.concat(resdatas);
        });
        const saveSorting = () => __awaiter(this, void 0, void 0, function* () {
            console.log(sorted.value);
            if (elements.value.length < 2) {
                VueSimpleAlert.alert("Das Sortieren von einer Datei ist nicht möglich! Sie können diese PDF-Datei direkt aus dem Projekt, im Reiter PDF, herunterladen.", "", "error", alertOptions).then(() => {
                    setDisabled.value = true;
                });
                return false;
            }
            console.log(elements.value);
            if (sorted.value.length < 2) {
                sorted.value = elements.value;
            }
            try {
                const response = yield axios.post('/api/save-sorting', { sorting: sorted.value, project: project.value });
                if (response.status === 200) {
                    yield VueSimpleAlert.alert('Die Sortierung ist gesichert.', '', 'success', successOptions);
                    setDisabled.value = false;
                }
                if (response.status !== 200) {
                    yield VueSimpleAlert.alert('Beim Sichern der Daten ist ein Fehler aufgetreten.', "", "error", alertOptions);
                    setDisabled.value = true;
                }
            }
            catch (error) {
                VueSimpleAlert.alert("Beim Sichern der Daten ist ein Fehler aufgetreten!", "", "error", alertOptions).then(() => {
                    console.error(error);
                });
            }
        });
        const handleEvent = () => {
            var _a;
            const results = (_a = sortable.value) === null || _a === void 0 ? void 0 : _a.sortable.toArray();
            let ordered = [];
            if (results && elements.value) {
                results.forEach(function (result) {
                    if (result) {
                        elements.value.forEach(function (element) {
                            if (result === element.basename) {
                                ordered.push(element);
                            }
                        });
                    }
                });
            }
            sorted.value = ordered;
        };
        const add = () => {
            if (setDisabled.value) {
                VueSimpleAlert.alert("Ohne Sortierung kann kein Rezeptheft erstellt werden.", "", "error", alertOptions).then(() => { });
                return setDisabled.value;
            }
            window.location.href = '/merge/' + project.value;
        };
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield fetchData();
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(project.value), 1),
                    _createElementVNode("section", _hoisted_4, [
                        _createVNode(_unref(Sortable), {
                            list: elements.value,
                            "item-key": "basename",
                            class: "p-3",
                            tag: "div",
                            ref_key: "sortable",
                            ref: sortable,
                            onEnd: _cache[0] || (_cache[0] = () => handleEvent())
                        }, {
                            item: _withCtx(({ element, index }) => [
                                (_openBlock(), _createElementBlock("div", {
                                    class: "draggable cursor-move p-3 my-1 text-sm text-ellipsis border border-solid border-gray-dark bg-semitransparent",
                                    key: index,
                                    "data-id": element.basename
                                }, _toDisplayString(element.basename), 9, _hoisted_5))
                            ]),
                            _: 1
                        }, 8, ["list"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                            href: '/project/' + project.value,
                            class: "px-6 py-3 text-white no-underline bg-orange rounded"
                        }, " zum Projekt ", 8, _hoisted_7),
                        _createElementVNode("button", {
                            onClick: saveSorting,
                            class: "px-6 py-3 text-white no-underline bg-orange rounded"
                        }, "Sortierung sichern"),
                        _createElementVNode("a", {
                            href: "",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (add()), ["prevent"])),
                            class: _normalizeClass(["px-6 py-3 text-white no-underline bg-orange rounded", { 'disabled': setDisabled.value }])
                        }, " Booklet erstellen ", 2)
                    ])
                ]),
                _hoisted_8
            ]));
        };
    } }));
